(function () {
    "use strict";

    function initializeGuide(root) {
        if (root.dataset.vlpGuideReady === "true") {
            return;
        }
        root.dataset.vlpGuideReady = "true";

        var search = root.querySelector("[data-vlp-search]");
        var clearSearch = root.querySelector("[data-vlp-search-clear]");
        var searchStatus = root.querySelector("[data-vlp-search-status]");
        var globalResults = root.querySelector("[data-vlp-global-results]");
        var globalResultsList = root.querySelector("[data-vlp-global-results-list]");
        var globalResultsEmpty = root.querySelector("[data-vlp-global-results-empty]");
        var symbolToggle = root.querySelector("[data-vlp-symbol-toggle]");
        var sectionLinks = root.querySelector("[data-vlp-section-links]");
        var navLinks = Array.prototype.slice.call(root.querySelectorAll("[data-vlp-nav-link]"));
        var sidebar = root.querySelector("[data-vlp-sidebar]");
        var mobileToggle = root.querySelector("[data-vlp-mobile-toggle]");
        var backdrop = root.querySelector("[data-vlp-backdrop]");
        var lightbox = root.querySelector("[data-vlp-lightbox]");
        var lightboxImage = root.querySelector("[data-vlp-lightbox-image]");
        var lightboxClose = root.querySelector("[data-vlp-lightbox-close]");
        var lastFocusedImage = null;
        var searchIndexPromise = null;
        var searchRequest = 0;

        function setActiveLink(id) {
            navLinks.forEach(function (link) {
                var isActive = link.getAttribute("href") === "#" + id;
                link.classList.toggle("is-active", isActive);
                if (isActive) {
                    link.setAttribute("aria-current", "location");
                } else {
                    link.removeAttribute("aria-current");
                }
            });
        }

        function closeMobileNavigation() {
            if (!sidebar || !mobileToggle || !backdrop) {
                return;
            }
            sidebar.classList.remove("is-open");
            backdrop.classList.remove("is-visible");
            mobileToggle.setAttribute("aria-expanded", "false");
            document.body.style.overflow = "";
        }

        function openMobileNavigation() {
            if (!sidebar || !mobileToggle || !backdrop) {
                return;
            }
            sidebar.classList.add("is-open");
            backdrop.classList.add("is-visible");
            mobileToggle.setAttribute("aria-expanded", "true");
            document.body.style.overflow = "hidden";
            if (search) {
                search.focus();
            }
        }

        function normalizeSearchValue(value) {
            var normalized = value.trim().toLocaleLowerCase();
            if (normalized.normalize) {
                normalized = normalized.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
            }
            return normalized;
        }

        function loadSearchIndex() {
            if (searchIndexPromise) {
                return searchIndexPromise;
            }
            var indexUrl = root.getAttribute("data-vlp-search-index");
            if (!indexUrl) {
                return Promise.reject(new Error("Documentation search index URL is missing."));
            }
            searchIndexPromise = fetch(indexUrl, { credentials: "same-origin" })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error("Documentation search index returned " + response.status + ".");
                    }
                    return response.json();
                })
                .then(function (index) {
                    return Array.isArray(index.search_entries) ? index.search_entries : [];
                })
                .catch(function (error) {
                    searchIndexPromise = null;
                    throw error;
                });
            return searchIndexPromise;
        }

        function scoreSearchEntry(entry, query, tokens) {
            var searchText = normalizeSearchValue(entry.search_text || "");
            var matches = tokens.every(function (token) {
                return searchText.indexOf(token) !== -1;
            });
            if (!matches) {
                return -1;
            }
            var article = normalizeSearchValue(entry.article || "");
            var section = normalizeSearchValue(entry.section || "");
            var score = entry.kind === "article" ? 5 : 0;
            if (article === query) {
                score += 120;
            } else if (article.indexOf(query) === 0) {
                score += 80;
            } else if (article.indexOf(query) !== -1) {
                score += 50;
            }
            if (section === query) {
                score += 110;
            } else if (section.indexOf(query) === 0) {
                score += 70;
            } else if (section.indexOf(query) !== -1) {
                score += 40;
            }
            if (searchText.indexOf(query) !== -1) {
                score += 20;
            }
            return score;
        }

        function appendSearchResult(entry) {
            var link = document.createElement("a");
            link.className = "vlp-guide-global-result";
            link.href = entry.url;

            var title = document.createElement("strong");
            title.textContent = entry.article;
            link.appendChild(title);

            var context = document.createElement("span");
            context.className = "vlp-guide-global-result-context";
            context.textContent = entry.section
                ? entry.category + " / " + entry.section
                : entry.category + " / Article overview";
            link.appendChild(context);

            var excerpt = document.createElement("span");
            excerpt.className = "vlp-guide-global-result-excerpt";
            excerpt.textContent = entry.excerpt;
            link.appendChild(excerpt);
            globalResultsList.appendChild(link);
        }

        function applySearch() {
            var query = normalizeSearchValue(search.value);
            var request = searchRequest + 1;
            searchRequest = request;
            clearSearch.classList.toggle("is-visible", query.length > 0);
            globalResultsList.textContent = "";
            globalResultsEmpty.textContent = "No documentation matches your search.";
            globalResultsEmpty.hidden = true;

            if (!query) {
                globalResults.hidden = true;
                searchStatus.textContent = "";
                return;
            }
            if (query.length < 2) {
                globalResults.hidden = false;
                searchStatus.textContent = "Enter at least 2 characters";
                return;
            }

            globalResults.hidden = false;
            searchStatus.textContent = "Searching documentation...";
            var tokens = query.split(/\s+/).filter(Boolean);
            loadSearchIndex()
                .then(function (entries) {
                    if (request !== searchRequest) {
                        return;
                    }
                    var matches = entries
                        .map(function (entry) {
                            return { entry: entry, score: scoreSearchEntry(entry, query, tokens) };
                        })
                        .filter(function (match) {
                            return match.score >= 0;
                        })
                        .sort(function (left, right) {
                            if (right.score !== left.score) {
                                return right.score - left.score;
                            }
                            return left.entry.article.localeCompare(right.entry.article);
                        });
                    matches.slice(0, 12).forEach(function (match) {
                        appendSearchResult(match.entry);
                    });
                    globalResultsEmpty.hidden = matches.length > 0;
                    searchStatus.textContent = matches.length > 12
                        ? "Showing 12 of " + matches.length + " matching results"
                        : matches.length
                            ? matches.length + " matching result" + (matches.length === 1 ? "" : "s")
                            : "No matching results";
                })
                .catch(function () {
                    if (request !== searchRequest) {
                        return;
                    }
                    globalResultsEmpty.hidden = false;
                    globalResultsEmpty.textContent = "Search is temporarily unavailable. Please try again.";
                    searchStatus.textContent = "Search unavailable";
                });
        }

        function openLightbox(image) {
            if (!lightbox || !lightboxImage || !lightboxClose) {
                return;
            }
            lastFocusedImage = image;
            lightboxImage.src = image.currentSrc || image.src;
            lightboxImage.alt = image.alt;
            lightboxImage.width = image.naturalWidth || Number(image.getAttribute("width")) || 1;
            lightboxImage.height = image.naturalHeight || Number(image.getAttribute("height")) || 1;
            lightbox.classList.add("is-open");
            lightbox.setAttribute("aria-hidden", "false");
            document.body.style.overflow = "hidden";
            lightboxClose.focus();
        }

        function closeLightbox() {
            if (!lightbox || !lightboxImage) {
                return;
            }
            lightbox.classList.remove("is-open");
            lightbox.setAttribute("aria-hidden", "true");
            lightboxImage.removeAttribute("src");
            document.body.style.overflow = "";
            if (lastFocusedImage) {
                lastFocusedImage.focus();
            }
        }

        if (symbolToggle && sectionLinks) {
            symbolToggle.addEventListener("click", function () {
                var expanded = symbolToggle.getAttribute("aria-expanded") === "true";
                symbolToggle.setAttribute("aria-expanded", expanded ? "false" : "true");
                sectionLinks.hidden = expanded;
            });
        }

        search.addEventListener("input", applySearch);
        search.addEventListener("focus", function () {
            loadSearchIndex().catch(function () {
                // A later search retries the request and presents the user-facing error if it still fails.
            });
        });
        clearSearch.addEventListener("click", function () {
            search.value = "";
            applySearch();
            search.focus();
        });
        globalResultsList.addEventListener("click", function (event) {
            if (event.target.closest("a") && window.innerWidth <= 900) {
                closeMobileNavigation();
            }
        });

        navLinks.forEach(function (link) {
            link.addEventListener("click", function () {
                var id = link.getAttribute("href").slice(1);
                setActiveLink(id);
                if (window.innerWidth <= 900) {
                    closeMobileNavigation();
                }
            });
        });

        if (mobileToggle && sidebar && backdrop) {
            mobileToggle.addEventListener("click", function () {
                if (sidebar.classList.contains("is-open")) {
                    closeMobileNavigation();
                } else {
                    openMobileNavigation();
                }
            });
            backdrop.addEventListener("click", closeMobileNavigation);
        }

        root.querySelectorAll(".vlp-guide-image img, .vlp-guide-gallery img").forEach(function (image) {
            image.tabIndex = 0;
            image.setAttribute("role", "button");
            image.setAttribute("aria-label", "Open larger image: " + image.alt);
            image.addEventListener("click", function () {
                openLightbox(image);
            });
            image.addEventListener("keydown", function (event) {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openLightbox(image);
                }
            });
        });

        if (lightboxClose && lightbox) {
            lightboxClose.addEventListener("click", closeLightbox);
            lightbox.addEventListener("click", function (event) {
                if (event.target === lightbox) {
                    closeLightbox();
                }
            });
        }

        document.addEventListener("keydown", function (event) {
            if (event.key !== "Escape") {
                return;
            }
            if (lightbox && lightbox.classList.contains("is-open")) {
                closeLightbox();
            } else if (sidebar && mobileToggle && sidebar.classList.contains("is-open")) {
                closeMobileNavigation();
                mobileToggle.focus();
            }
        });

        if ("IntersectionObserver" in window) {
            var headings = Array.prototype.slice.call(root.querySelectorAll(".vlp-guide-article h2[id], .vlp-guide-article h3[id]"));
            var observer = new IntersectionObserver(function (entries) {
                var visible = entries.filter(function (entry) {
                    return entry.isIntersecting;
                });
                if (visible.length) {
                    visible.sort(function (left, right) {
                        return left.boundingClientRect.top - right.boundingClientRect.top;
                    });
                    setActiveLink(visible[0].target.id);
                }
            }, { rootMargin: "-10% 0px -78% 0px", threshold: [0, 1] });
            headings.forEach(function (heading) {
                observer.observe(heading);
            });
        }

        var initialId = window.location.hash.slice(1);
        if (initialId && root.querySelector("#" + CSS.escape(initialId))) {
            setActiveLink(initialId);
        } else if (navLinks.length) {
            setActiveLink(navLinks[0].getAttribute("href").slice(1));
        }
        applySearch();
    }

    function initializeAllGuides() {
        document.querySelectorAll("[data-vlp-guide]").forEach(initializeGuide);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initializeAllGuides);
    } else {
        initializeAllGuides();
    }

    document.addEventListener("shopify:section:load", function (event) {
        var root = event.target.querySelector("[data-vlp-guide]");
        if (root) {
            initializeGuide(root);
        }
    });
}());
